import { error, finish } from '../../../modules/system-settings/actions/get-cashout-settings';
import api from '../../../api';

export function request(dispatch) {
    api.get(`/cashout/settings`, void 0, { cache: true }).then(
        data => dispatch(finish(data)),
        (errors) => dispatch(error(errors))
    );
}
